import React from 'react';
import BaseIcon from './BaseIcon';


const OpenNewIcon = props => (
  <BaseIcon {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path d="M14,3.41421356 L8.70710678,8.70710678 C8.31658249,9.09763107 7.68341751,9.09763107 7.29289322,8.70710678 C6.90236893,8.31658249 6.90236893,7.68341751 7.29289322,7.29289322 L12.5857864,2 L9,2 C8.44771525,2 8,1.55228475 8,1 C8,0.44771525 8.44771525,0 9,0 L16,0 L16,7 C16,7.55228475 15.5522847,8 15,8 C14.4477153,8 14,7.55228475 14,7 L14,3.41421356 Z M1.09440235e-13,9.5 L1.11022302e-13,-2.79880645e-14 L3.94873047,-2.72626945e-14 C4.50101522,-2.71612414e-14 4.94873047,0.44771525 4.94873047,1 C4.94873047,1.55228475 4.50101522,2 3.94873047,2 L2,2 L2,9.5 L2,14 L14,14 L14,12.0524902 C14,11.5002055 14.4477153,11.0524902 15,11.0524902 C15.5522847,11.0524902 16,11.5002055 16,12.0524902 L16,16 L1.33226763e-14,16 L1.33226763e-14,9.5 Z" fillRule="nonzero" />
    </g>
  </BaseIcon>
);

export default OpenNewIcon;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Icons/OpenNewIcon.jsx